enum InterfacesFormulario{
    
    CONTACTO = 1,
    PEP = 2,
    CLIENTE = 3,
    LEGAL = 4,
    ACCNATURAL = 5,
    ACCJURIDICO = 6,
    ADICIONAL = 7,
    FINANCIERA = 8,
}

export default InterfacesFormulario